import { useNavigate } from 'react-router-dom';
import { PURPLE, MINT, hexToRgba } from '../../utils/designUtils';

export default function InquiryPage() {
    const navigate = useNavigate();

    return (
        <div style={{ background: '#f5f4fa', minHeight: 'calc(100vh - 61px)', padding: '40px clamp(16px, 4vw, 32px) 64px' }}>
            <div style={{ maxWidth: 640, margin: '0 auto' }}>

                {/* 뒤로가기 */}
                <button
                    onClick={() => navigate(-1)}
                    style={{
                        display: 'inline-flex', alignItems: 'center', gap: 6,
                        background: 'none', border: 'none', cursor: 'pointer',
                        fontSize: 13, color: '#7a7989', marginBottom: 20, padding: 0,
                        fontFamily: 'inherit',
                    }}
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M19 12H5M12 5l-7 7 7 7"/>
                    </svg>
                    돌아가기
                </button>

                <div style={{
                    background: 'white', borderRadius: 16,
                    border: '1px solid rgba(124,107,217,0.12)',
                    boxShadow: '0 4px 24px rgba(124,107,217,0.08)',
                    overflow: 'hidden',
                }}>
                    {/* 헤더 */}
                    <div style={{ padding: '28px 32px', borderBottom: '1px solid #f0eff5' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                            <span style={{ width: 4, height: 18, borderRadius: 2, background: `linear-gradient(180deg, ${PURPLE}, ${MINT})`, display: 'inline-block', flexShrink: 0 }}/>
                            <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#1f1d2e', letterSpacing: '-0.01em' }}>
                                문의하기
                            </h1>
                        </div>
                        <p style={{ margin: 0, fontSize: 13.5, color: '#7a7989', lineHeight: 1.6 }}>
                            WorkiTalk 서비스 이용 중 불편한 점이 있거나 도움이 필요하시면 아래 연락처로 문의해 주세요.
                        </p>
                    </div>

                    <div style={{ padding: '28px 32px', display: 'flex', flexDirection: 'column', gap: 28 }}>

                        {/* 서비스 소개 */}
                        <div>
                            <div style={{ fontSize: 11.5, fontWeight: 600, color: '#8b8a99', letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 12 }}>
                                서비스 소개
                            </div>
                            <p style={{ margin: 0, fontSize: 14, color: '#3a3849', lineHeight: 1.8 }}>
                                WorkiTalk는 기업 내 업무 협업을 위한 올인원 솔루션입니다.<br/>
                                조직 관리, 전자결재, 프로젝트, 일정, 보고서 등 다양한 기능을 하나의 플랫폼에서 제공합니다.
                            </p>
                        </div>

                        <div style={{ height: 1, background: '#f0eff5' }}/>

                        {/* 문의처 */}
                        <div>
                            <div style={{ fontSize: 11.5, fontWeight: 600, color: '#8b8a99', letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 12 }}>
                                문의처
                            </div>
                            <div style={{ background: '#f7f6fb', borderRadius: 10, padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 10 }}>
                                {[
                                    { label: '이메일', value: 'ssolegate@gmail.com' },
                                    { label: '운영시간', value: '평일 09:00 – 18:00 (주말·공휴일 제외)' },
                                ].map(({ label, value }) => (
                                    <div key={label} style={{ display: 'flex', gap: 20, fontSize: 13.5 }}>
                                        <span style={{ fontWeight: 600, color: '#3a3849', minWidth: 56 }}>{label}</span>
                                        <span style={{ color: value ? '#5d5b6e' : hexToRgba(PURPLE, 0.35) }}>
                                            {value || '미입력'}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div style={{ height: 1, background: '#f0eff5' }}/>

                        {/* 추가 안내 */}
                        <div>
                            <div style={{ fontSize: 11.5, fontWeight: 600, color: '#8b8a99', letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 12 }}>
                                추가 안내
                            </div>
                            <p style={{ margin: 0, fontSize: 14, color: '#3a3849', lineHeight: 1.8 }}>
                                문의 내용 접수 후 영업일 기준 1~2일 이내 담당자가 이메일로 회신드립니다.<br/>
                                계정 발급 및 조직 등록은 담당자 확인 후 안내드립니다.
                            </p>
                        </div>

                    </div>
                </div>

                <div style={{ textAlign: 'center', marginTop: 28, fontSize: 12, color: '#b6b5c1' }}>
                    © 2026 WorkiTalk Inc.
                </div>
            </div>
        </div>
    );
}
